import { type ReactElement, type ReactNode } from 'react'
import cn from 'classnames'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { useSnapshot } from 'valtio'
import { proxyGlobalAuth } from '../../../proxies/proxyGlobalAuth'

interface NavigationButtonProps {
  path: string
  expanded: boolean
  iconComponent: ReactNode
  text: string
  title?: string
}

export function NavigationButton ({ expanded, path, text, iconComponent, title }: NavigationButtonProps): ReactElement {
  const router = useRouter()
  const active = router.pathname === path
  const { siteTheme: { sideNavBarButton } } = useSnapshot(proxyGlobalAuth)
  return (
    <Link href={path}>
      <div
        className={
          cn(
            sideNavBarButton.classes,
            'flex items-center py-4 cursor-pointer ',
            expanded ? 'justify-start px-4' : 'justify-center px-2',
            active && sideNavBarButton.activeClasses
          )
        }
        title={title}
      >
        <div className="w-6 h-6 flex justify-center items-center">
          {iconComponent}
        </div>
        {expanded && (
          <div
            className={cn('ml-4 h-6 my-1 text-sm', active && 'font-semibold')}
            style={{ color: active ? '#FFFFFF' : '#7F95A0' }}
          >
            {text}
          </div>
        )}
      </div>
    </Link>
  )
}
